import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const getFileName = (role) => {
  const date = new Date().toISOString().split("T")[0];

  switch (role) {
    case "parent":
      return `GrowthLoop-Parent-${date}.pdf`;

    case "educator":
      return `GrowthLoop-Educator-${date}.pdf`;

    case "doctor":
      return `GrowthLoop-Doctor-${date}.pdf`;

    case "observer":
      return `GrowthLoop-Observer-${date}.pdf`;

    case "overall":
      return `GrowthLoop-Overall-${date}.pdf`;

    default:
      return `GrowthLoop-${date}.pdf`;
  }
};

const GLPdfExporter = {
  download: async (role) => {
    const element = document.getElementById(`assessment-${role}`);

    if (!element) return;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#111827",
      scrollY: -window.scrollY,
    });

    const image = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const imageHeight = (canvas.height * pageWidth) / canvas.width;

    let heightLeft = imageHeight;
    let position = 0;

    pdf.addImage(image, "PNG", 0, position, pageWidth, imageHeight);

    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imageHeight;
      pdf.addPage();
      pdf.addImage(image, "PNG", 0, position, pageWidth, imageHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(getFileName(role));
  },
};

export default GLPdfExporter;